import type { CategoryGroup, ListCategory } from '@/lib/movieTypes';

export const BRAND_NAME = '国语影音资源库';
export const BRAND_SLOGAN = '汇集国语对白高清影音资源，发现值得一看的精彩作品';

export const categoryGroups: CategoryGroup[] = [
  {
    type: 'movie',
    name: '电影',
    slug: 'movie',
    description: '精选国语对白电影作品，涵盖剧情、动作、爱情、悬疑与科幻等多元题材。',
    icon: 'ri-film-line',
    subs: [
      { id: 'drama', name: '剧情' },
      { id: 'action', name: '动作' },
      { id: 'romance', name: '爱情' },
      { id: 'suspense', name: '悬疑' },
      { id: 'scifi', name: '科幻' },
    ],
  },
  {
    type: 'tv',
    name: '电视剧',
    slug: 'tv',
    description: '热播国语对白剧集，都市、古装、悬疑、家庭题材应有尽有。',
    icon: 'ri-tv-line',
    subs: [
      { id: 'urban', name: '都市' },
      { id: 'costume', name: '古装' },
      { id: 'suspense', name: '悬疑' },
      { id: 'family', name: '家庭' },
    ],
  },
  {
    type: 'variety',
    name: '综艺',
    slug: 'variety',
    description: '轻松有趣的国语对白综艺节目，真人秀、脱口秀、音乐舞台一网打尽。',
    icon: 'ri-mic-line',
    subs: [
      { id: 'reality', name: '真人秀' },
      { id: 'talk', name: '脱口秀' },
      { id: 'music', name: '音乐' },
    ],
  },
  {
    type: 'documentary',
    name: '纪录片',
    slug: 'documentary',
    description: '深度国语对白纪录片，自然、人文、历史视角记录真实世界。',
    icon: 'ri-earth-line',
    subs: [
      { id: 'nature', name: '自然' },
      { id: 'humanities', name: '人文' },
      { id: 'history', name: '历史' },
    ],
  },
];

export const listCategories: ListCategory[] = [
  { id: 'movie-drama', name: '剧情片', type: 'movie', typeName: '电影', description: '细腻讲述人物命运的国语对白剧情电影集锦。' },
  { id: 'movie-action', name: '动作片', type: 'movie', typeName: '电影', description: '节奏紧张、场面过瘾的国语对白动作电影。' },
  { id: 'movie-romance', name: '爱情片', type: 'movie', typeName: '电影', description: '关于心动与告白的国语对白爱情电影。' },
  { id: 'movie-suspense', name: '悬疑片', type: 'movie', typeName: '电影', description: '层层反转、扣人心弦的国语对白悬疑电影。' },
  { id: 'movie-scifi', name: '科幻片', type: 'movie', typeName: '电影', description: '想象未来的国语对白科幻电影精选。' },
  { id: 'tv-urban', name: '都市剧', type: 'tv', typeName: '电视剧', description: '聚焦都市生活的国语对白电视剧。' },
  { id: 'tv-costume', name: '古装剧', type: 'tv', typeName: '电视剧', description: '韵味十足的国语对白古装剧集。' },
  { id: 'tv-suspense', name: '悬疑剧', type: 'tv', typeName: '电视剧', description: '追凶探案的国语对白悬疑剧集。' },
  { id: 'tv-family', name: '家庭剧', type: 'tv', typeName: '电视剧', description: '温暖治愈的国语对白家庭剧。' },
  { id: 'variety-reality', name: '真人秀', type: 'variety', typeName: '综艺', description: '真实有趣的国语对白真人秀节目。' },
  { id: 'variety-talk', name: '脱口秀', type: 'variety', typeName: '综艺', description: '金句频出的国语对白脱口秀。' },
  { id: 'variety-music', name: '音乐综艺', type: 'variety', typeName: '综艺', description: '舞台闪耀的国语对白音乐综艺。' },
  { id: 'documentary-nature', name: '自然纪录片', type: 'documentary', typeName: '纪录片', description: '记录山河生灵的国语对白自然纪录片。' },
  { id: 'documentary-humanities', name: '人文纪录片', type: 'documentary', typeName: '纪录片', description: '记录人间烟火的国语对白人文纪录片。' },
  { id: 'documentary-history', name: '历史纪录片', type: 'documentary', typeName: '纪录片', description: '回望岁月长河的国语对白历史纪录片。' },
];

export const regionOptions = ['中国大陆', '中国香港', '中国台湾', '韩国', '日本', '美国', '英国'];

export const yearOptions = [2026, 2025, 2024, 2023, 2022, 2021, 2020];

export const sortOptions = [
  { value: 'latest', label: '最新更新' },
  { value: 'rating', label: '评分最高' },
  { value: 'hot', label: '最受欢迎' },
  { value: 'year', label: '年份最新' },
];